import React  from 'react';
import Classes from "classnames";

export default function renderListGroupListHeader(id, props) {
    const { data, className } = props;

    const classes = Classes(className, 'gd-field-list-multi-group-list-header');

    const customField = gd.session.customFields.get(id)
    const item = _.find(customField.params.listItems, i=>i.id === data.value);

    return (
        <div className={classes}>
            <div className="group-list-header-value">{item ? item.value : "Not selected"}</div>
        </div>
    );
}